import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TreeView from '../components/TreeView';
import SimpleSection from '../components/SimpleSection';
import AboutLayout from '../layouts/AboutLayout';
import { ChevronUp } from 'react-bootstrap-icons';
import back from '../images/backgrounds/header-contactenos.jpg';
import GLIFOSCollectionGridViewer from '../viewer/GLIFOSCollectionGridViewer';
import Pagination from 'components/Pagination/Pagination';
import { searchService } from 'services/libraryServices';
import { Funnel } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import LoadingBody from 'components/loadingBody/loadingBody';
import { obtenerFiltros } from 'services/libraryServices';
import { FilterContext } from 'contextos/FilterContext';
import { IdiomaContext } from 'contextos/IdiomaFacetContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { hasFilters, saveFilters } from 'helpers/localStorageHelper';
import { formatLenguajeFacet } from 'helpers/searchHelper';
import BasicLayout from 'common/layouts/BasicLayout/BasicLayout';
import SearchBar from 'modules/website/components/SearchBar/SearchBar';
import SearchField from 'components/SearchField';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

export function ISADgCollection() {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const [mySelectedPhotos, setMySelectedPhotos] = useState({
		isLoading: true,
		loaded: '',
		error: false,
		result_header: {},
		payload: [],
		idiomaFacet: [],
	});
	const [scrollBtn, setScrollBtn] = useState(false);
	const [filters, setFilters] = useState([]);
	const [urlParams, setUrlParams] = useState({ verbatim: false, query: '' });

	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: location.pathname + location.search,
		});
	}, [location.pathname, location.search]);

	/* useEffect(() => {
		const fetchFilters = async () => {
			if (!hasFilters()) {
				const filtrosGuardados = await obtenerFiltros();
				saveFilters(filtrosGuardados);
			}
			const filtros = JSON.parse(localStorage.getItem('filtros'));
			setFilters(JSON.parse(filtros.value));
		};
		fetchFilters();
	}, []); */
	useEffect(() => {
		const fetchFilters = async () => {
			if (!hasFilters()) {
				const filtrosGuardados = await obtenerFiltros();
				saveFilters(filtrosGuardados);
			}
			const filtros = await obtenerFiltros();
			//console.log(filtros[0]);
			setFilters(filtros);
		};
		fetchFilters();
	}, []);

	useEffect(() => {
		if (mySelectedPhotos.isLoading) {
			const fetchData = async () => {
				const response = await searchService(window.location.search);
				// console.log(response);
				if (!response.success) {
					setMySelectedPhotos((prev) => ({
						...prev,
						isLoading: false,
						error: true,
						idiomaFacet: formatLenguajeFacet(response?.idiomas),
					}));
					return;
				}
				if (!response.records.record) {
					response.records.record = [];
				}
				//console.log(Object.prototype.toString.call(response.records.record));
				//console.log((response.records.record));
				if (
					Object.prototype.toString.call(response.records.record) !==
					'[object Array]'
				) {
					var aux = [response.records.record];
					// console.log(aux);
					response.records.record = aux;
				}
				setMySelectedPhotos({
					isLoading: false,
					payload: response.records.record,
					error: false,
					result_header: formatHeader(response.result_header),
					idiomaFacet: formatLenguajeFacet(response?.idiomas),
				});
			};
			fetchData();
		}
	}, [mySelectedPhotos, setMySelectedPhotos]);

	useEffect(() => {
		setMySelectedPhotos((prev) => ({ ...prev, isLoading: true }));
	}, [searchParams]);

	const formatHeader = (value) => {
		if (value?.total_results !== 'NaN') {
			value.total_results_parser = parseInt(
				value.total_results
			).toLocaleString('en-US');
		}
		return value;
	};

	window.onscroll = function () {
		if (window.scrollY > 300) {
			setScrollBtn(true);
		} else {
			setScrollBtn(false);
		}
	};
	const handleClean = () => {
		// window.history.pushState(null, null, ``);
		navigate(`?`);
		setMySelectedPhotos({ ...mySelectedPhotos, isLoading: true });
	};
	// maneja el formulario
	const handleSubmit = (e, pagination = false) => {
		/* console.log("ENTRA ACAAAAA") */
		if (pagination) {
			setMySelectedPhotos({ ...mySelectedPhotos, isLoading: true }); // No recarga la pagina y hace la peticion
			return;
		}
		if (e) {
			/* console.log("ENTRA ACAAAAA") */
			e.preventDefault();
			submitForm(e.target.elements);
			return;
		}
		const forms = document.getElementsByName('searchForm');
		/* console.log(forms.length)
		console.log(forms) */
		if (forms.length > 2) {
			submitForm(forms[2].elements);
		} else {
			submitForm(forms[0].elements);
		}
	};
	// maneja el formulario
	const submitForm = (elements, justReturnString = false) => {
		const searchValue = document.getElementById('searchValue');
		//const searchValue = document.getElementsByName('searchForm');
		// console.log(Array.from(elements));
		const params = Array.from(elements)
			.concat([searchValue]) // Get all elements in the form
			.filter((item) =>
				['input', 'select'].includes(item.tagName.toLowerCase())
			) // Filter only input and select elements
			.map((input) => ({ name: input.name, value: input.value })) // Format input values in json
			.filter((item) => item.name !== ''); // Remove blank inputs // Remove duplicate

		//console.log(params);
		var paramsResult = params
			.map((param) => `${param.name}=${encodeURIComponent(param.value)}`)
			.join('&');
		/* if (urlParams.verbatim) {
	  paramsResult += "&verbatim=1";
	}
	if (justReturnString) return paramsResult;
	const idiomaParam = searchParams.get("idioma");
	if (idiomaParam) paramsResult += "&idioma=" + idiomaParam; */
		// window.location.href = `?${paramsResult}`;
		if (window.location.search !== '?' + paramsResult) {
			setMySelectedPhotos({ ...mySelectedPhotos, idiomaFacet: [] });
		}
		navigate(`?${paramsResult}`);
		// window.history.pushState(null, null, `?${paramsResult}`);
		// setMySelectedPhotos({ isLoading: true }); // No recarga la pagina y hace la peticion
	};
	// maneja el formulario para barra de busqueda
	const handleSearchBarSubmit = (e) => {
		e.preventDefault();
		const forms = document.getElementsByName('searchForm');
		submitForm(forms[1].elements);
	};

	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	return (
		<FilterContext.Provider
			value={{
				handleSubmit: handleSubmit,
				filters: filters,
				cleanner: handleClean,
				setUrlParams: setUrlParams,
				navigate: navigate,
				handleSearchBarSubmit: handleSearchBarSubmit,
			}}
		>
			<BasicLayout
				title='Búsqueda'
				subtitle={'subtitle'}
				notFoud={false}
				backgroundImage={back}
			>
				<SimpleSection className='c-welcome-cirma'>
					<Container>
						<IdiomaContext.Provider
							value={{
								idiomaFacet: mySelectedPhotos.idiomaFacet,
								setMySelectedPhotos: setMySelectedPhotos,
								submitForm: submitForm,
								navigate: navigate,
								searchParams: searchParams,
							}}
						>
							<Row>
								<Col lg={3} className='d-none d-lg-block'>
									<TreeView />
								</Col>
								<div className='d-lg-none row py-2 sticky-top '>
									<div className='bg-white border shadow-sm rounded col-4'>
										<button
											className='col-12 btn btn-sm text-start'
											data-bs-toggle='modal'
											data-bs-target='#searchfiltersmodal'
											onClick={handleShow}
										>
											<Funnel /> Filters
										</button>
									</div>
								</div>
								<Col lg={9}>
									{/* <form
										action={``}
										onSubmit={handleSubmit}
										name='searchForm'
										id='btnFulltext'
									> */}
									<SearchField />
									{/* </form> */}
									{!mySelectedPhotos.isLoading ? (
										<div>
											<div className='row px-0 px-lg-3 my-3'>
												<Pagination
													result_header={
														mySelectedPhotos.result_header
													}
												/>
											</div>
											<GLIFOSCollectionGridViewer
												mySelectedPhotos={
													mySelectedPhotos
												}
											/>
											{mySelectedPhotos.payload.length <
												1 && (
													<div className='row px-0 px-lg-3 notF'>
														<p>
															No results were found
															for the search
														</p>
													</div>
												)}
											<div className='row px-0 px-lg-3 my-3'>
												<Pagination
													result_header={
														mySelectedPhotos.result_header
													}
												/>
											</div>
										</div>
									) : (
										<LoadingBody />
									)}
								</Col>
								<Col>
									{scrollBtn && (
										<div
											className='btn btn-primary btn-floating btn-sm '
											id='btn-back-to-top'
											onClick={() => {
												window.scrollTo(0, 0);
											}}
										>
											<ChevronUp
												style={{
													stroke: 'white',
													strokeWidth: '1',
												}}
											/>
										</div>
									)}
								</Col>
							</Row>

							<Modal
								show={show}
								onHide={handleClose}
								style={{ zIndex: 1200 }}
							>
								<Modal.Header closeButton>
									<Modal.Title>Search filters</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<TreeView />
								</Modal.Body>
								<Modal.Footer>
									<Button
										variant='secondary'
										onClick={handleClose}
									>
										Close
									</Button>
								</Modal.Footer>
							</Modal>
						</IdiomaContext.Provider>
					</Container>
				</SimpleSection>
			</BasicLayout>
		</FilterContext.Provider>
	);
}
